export class OutOfTimeRequestFactor {
    outOfTimeRequestFactorId: number;
    factorSetId: number;
    
    outOfTimePercent: number;
    outOfTimeAmountPercent: number;
}